import React, { useState } from "react";
import { getCookie, logAction } from "./log.js";
import "../css/PopUpAddFolder.css";

const PopUpAddFolder = ({ object, onClose }) => {
    /**
     * folderName : état local contenant le nom du dossier saisi par l'utilisateur.
     * Initialisé à une chaîne vide, mis à jour au changement dans l'input texte.
     */
    const [folderName, setFolderName] = useState("");

    /**
     * API_URL : URL de base du serveur, récupérée depuis les variables
     * d'environnement via process.env.REACT_APP_API_URL.
     * Utilisée pour construire les requêtes fetch vers le serveur.
     */
    const API_URL = process.env.REACT_APP_API_URL;

    /**
     * handleSubmit : gestionnaire de soumission du formulaire.
     * Empêche le comportement par défaut, vérifie que le nom du dossier n'est pas vide,
     * appelle handleNewFolder pour créer le dossier, puis ferme la popup.
     * @param {Event} e - Événement de soumission du formulaire.
     */
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!folderName.trim()) {
            alert("Veuillez entrer un nom de dossier.");
            return;
        }
        await handleNewFolder();
        onClose();
    };

    /**
     * handleNewFolder : fonction asynchrone qui prépare et envoie la création
     * du nouveau dossier au serveur via une requête fetch.
     * Un Blob vide est envoyé pour rester compatible avec la même API que les fichiers.
     * Logue l'action de création en cas de succès.
     */
    const handleNewFolder = async () => {
        const formData = new FormData();
        formData.append("file", new Blob()); // Blob vide pour compatibilité API
        formData.append("dossier", object.id);
        formData.append("sousdossier", object.pathArray.join("\\"));
        formData.append("type", "D"); // Indique qu'il s'agit d'un dossier
        formData.append("nom", folderName);

        try {
            const response = await fetch(`${API_URL}/api/addNewObject.php`, {
                method: "POST",
                credentials: 'include',
                headers: {
                    "Accept": "application/json",
                },
                body: formData,
            });

            const result = await response.json();

            if (response.ok) {
                logAction({
                    action: "addFile",
                    dossierId: object.id,
                    utilisateurId: getCookie("userId"),
                    fichier: folderName,
                    path: object.pathArray.join("\\"),
                });
                onClose();
            } else {
                alert(`Erreur: ${result.error}`);
            }
        } catch (err) {
            console.error("Erreur lors de la création du dossier :", err);
            alert("Une erreur est survenue.");
        }
    };

    return (
        <div className="popupAdFolder-overlay">
            <div className="popupAdFolder-content">
                <div className="popupAdFolder-form">
                    <h3>Ajouter un dossier</h3>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Nom du dossier :</label>
                            <input
                                type="text"
                                value={folderName}
                                onChange={(e) => setFolderName(e.target.value)}
                            />
                        </div>

                        {/* <div className="popupAdFolder-buttons">
                            <button type="submit">Créer</button>
                            <button type="button" onClick={onClose}>Annuler</button>
                        </div> */}
                        <div className="flex justify-end -popupAdFile-buttons">
                            <button className="btn btn-success mr-2" type="submit">Ajouter</button>
                            <button className="btn" type="button" onClick={onClose}>Annuler</button>
                        </div>                        
                    </form>
                </div>
            </div>
        </div>
    );
};

export default PopUpAddFolder;
